import { render, staticRenderFns } from "./singlePost.vue?vue&type=template&id=624e680d&"
import script from "./singlePost.vue?vue&type=script&lang=js&"
export * from "./singlePost.vue?vue&type=script&lang=js&"
import style0 from "./singlePost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports